import script from "./SQLInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SQLInput.vue?vue&type=script&setup=true&lang=js"

import "./SQLInput.vue?vue&type=style&index=0&id=0ba77efa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba77efa"]])

export default __exports__